// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconRlusd } from "../../../icons/mono/build/icon-rlusd.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const RlusdIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconRlusd.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  RlusdIcon.displayName = 'RlusdIcon';
}

export default RlusdIcon;